import React, { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import contextActionType from "./context-action-type";

const {
    SET_STYLES_OPEN,
    GET_STYLES_OPEN,
    SET_ACTIVE_PLAYER,
    GET_ACTIVE_PLAYER,
    OPEN_SHORT_PRESET,
    CLOSE_SHORT_PRESET,
    GET_PRESET_MODAL_OPEN,
    SET_REFRAME_LOADING,
    GET_REFRAME_LOADING,
    SET_REFRAME_PROGRESS,
    GET_REFRAME_PROGRESS,
} = contextActionType;

const ShortsContext = createContext();

export const useShortsContext = () => {
    return useContext(ShortsContext);
};

const ShortsContextProvider = ({ children }) => {
    const [stylesOpen, setStylesOpen] = useState(false);
    const [activePlayerId, setActivePlayerId] = useState(null);
    const [presetModalOpen, setPresetModalOpen] = useState(false);
    const [isReframeLoading, setIsReframeLoadingCtx] = useState(false);
    const [reframeProgress, setReframeProgressCtx] = useState(0);
    const [sortValues, setSortValuesState] = useState({
        sortBy: "score",
        direction: "desc",
    });
    const [filterValues, setFilterValuesState] = useState({
        platforms: "all",
        type: "all",
    });

    const setShortsContext = (stateKey, value) => {
        if (stateKey === SET_STYLES_OPEN) {
            setStylesOpen(value);
        } else if (stateKey === SET_ACTIVE_PLAYER) {
            setActivePlayerId(value);
        } else if (stateKey === "SET_SORT_VALUES") {
            setSortValuesState(value);
        } else if (stateKey === "SET_FILTER_VALUES") {
            setFilterValuesState(value);
        } else if (stateKey === OPEN_SHORT_PRESET) {
            setPresetModalOpen(true);
            setStylesOpen(true);
        } else if (stateKey === CLOSE_SHORT_PRESET) {
            setPresetModalOpen(false);
            setStylesOpen(false);
        } else if (stateKey === SET_REFRAME_LOADING) {
            setIsReframeLoadingCtx(value);
        } else if (stateKey === SET_REFRAME_PROGRESS) {
            setReframeProgressCtx(value);
        }
    };

    const getShortsContext = (stateKey) => {
        if (stateKey === GET_STYLES_OPEN) {
            return stylesOpen;
        }
        if (stateKey === GET_ACTIVE_PLAYER) {
            return activePlayerId;
        }
        if (stateKey === "GET_SORT_VALUES") {
            return sortValues;
        }
        if (stateKey === "GET_FILTER_VALUES") {
            return filterValues;
        }
        if (stateKey === GET_PRESET_MODAL_OPEN) {
            return presetModalOpen;
        }
        if (stateKey === GET_REFRAME_LOADING) {
            return isReframeLoading;
        }
        if (stateKey === GET_REFRAME_PROGRESS) {
            return reframeProgress;
        }
        return null;
    };

    const contextValue = useMemo(() => ({
        setShortsContext,
        getShortsContext,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [stylesOpen, activePlayerId, sortValues, filterValues, presetModalOpen, isReframeLoading, reframeProgress]);

    return (
        <ShortsContext.Provider value={contextValue}>
            {children}
        </ShortsContext.Provider>
    );
};

ShortsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ShortsContextProvider;